// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as saveCaReducer } from './saveCa';
import { reducer as deleteCaReducer } from './deleteCa';
import { reducer as fetchDeliverablesAvailableReducer } from './fetchDeliverablesAvailable';
import { reducer as saveDeliverableAssignationReducer } from './saveDeliverableAssignation';
import { reducer as deleteAssignationReducer } from './deleteAssignation';
import { reducer as openCostModelReducer } from './openCostModel';
import { reducer as closeCostModelReducer } from './closeCostModel';
import { reducer as fetchCostByControlAccountReducer } from './fetchCostByControlAccount';
import { reducer as saveCostReducer } from './saveCost';
import { reducer as closeSnackBarReducer } from './closeSnackBar';
import { reducer as saveCostDetailReducer } from './saveCostDetail';
import { reducer as openReviewCostModelReducer } from './openReviewCostModel';
import { reducer as closeReviewCostModelReducer } from './closeReviewCostModel';

const reducers = [
  saveCaReducer,
  deleteCaReducer,
  fetchDeliverablesAvailableReducer,
  saveDeliverableAssignationReducer,
  deleteAssignationReducer,
  openCostModelReducer,
  closeCostModelReducer,
  fetchCostByControlAccountReducer,
  saveCostReducer,
  closeSnackBarReducer,
  saveCostDetailReducer,
  openReviewCostModelReducer,
  closeReviewCostModelReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/reducer.js